// extracted by mini-css-extract-plugin
module.exports = {"callToActionBox":"styles_callToActionBox__8OiuY"};